module.exports = __webpack_public_path__ + "img/网站3-08.cbc8e88f.jpg";